'use strict';
import angular from 'angular';

angular.module('ioclients.services', [])
    .service('IOClientService', IOClientService)
    .service('IOClientFactory', IOClientFactory);

IOClientService.$inject = ['IOClientFactory', '$q', 'Upload', 'AppConfig', '$http'];

function IOClientService(IOClientFactory, $q, Upload, AppConfig, $http) {
    let service = {};

    // Get all fields for a custom client form
    service.getCustomClientFormFields = function(clusterId) {
        let deferred = $q.defer();
        let params = {
            clusterId: clusterId,
        };

        IOClientFactory.customClientFormFields().get(params).$promise.then(function(data) {
            deferred.resolve(data.formFields);
        }, function(response) {
            console.log("error getting custom client form fields");
            deferred.reject(response);
        });

        return deferred.promise;
    };

    // Get all field groups for a custom client form
    service.getCustomClientFormFieldGroups = function(clusterId) {
        let deferred = $q.defer();
        let params = {
            clusterId: clusterId,
        };

        IOClientFactory.customClientFormFieldGroups().get(params).$promise.then(function(data) {
            deferred.resolve(data.formFieldGroups);
        }, function(response) {
            console.log("error getting custom client form field groups");
            deferred.reject(response);
        });

        return deferred.promise;
    };

    // Get all field values for a custom client form
    service.getCustomClientAttrs = function(clientId) {
        let deferred = $q.defer();
        let params = {
            clientId: clientId,
        };

        IOClientFactory.customClientAttrs().get(params).$promise.then(function(data) {
            deferred.resolve(data.clientAttrs);
        }, function(response) {
            console.log("error getting custom client form field values");
            deferred.reject(response);
        });

        return deferred.promise;
    };

    // Save or update custom client form field values
    service.saveCustomClientAttrs = function(clientAttrs) {
        let deferred = $q.defer();

        IOClientFactory.customClientAttrs().save(clientAttrs).$promise.then(function(data) {
            deferred.resolve(data.clientAttrs);
        }, function(response) {
            console.log("error saving custom client form field values");
            deferred.reject(response);
        });

        return deferred.promise;
    };

    return service;
}

IOClientFactory.$inject = ['$resource', 'AppConfig'];

function IOClientFactory($resource, AppConfig) {

    let factory = {};

    factory.customClientFormFields = function() {
        return $resource(AppConfig.IO_API_URL + 'clients/customClientFormFields', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.customClientFormFieldGroups = function() {
        return $resource(AppConfig.IO_API_URL + 'clients/customClientFormFieldGroups', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.customClientAttrs = function() {
        return $resource(AppConfig.IO_API_URL + 'clients/customClientAttrs', null, {
            'get': {
                method: 'GET',
                isArray: false
            },
            'save': {
                method: 'POST',
                isArray: false
            },
        });
    };

    return factory;
}